<template>
    <div class="glide bng-sport-top-banner">
        <div data-glide-el="track" class="glide__track">
            <ul class="glide__slides">
                <li v-for="banner in banners" :key="`${banner.image}_${banner.link}`" class="glide__slide">
                    <template v-if="banner.link && banner.link.indexOf('/') >= 0">
                        <a :href="banner.link"><img :src="banner.image"/></a>
                    </template>
                    <template v-else-if="banner.link && banner.link.indexOf('/') == -1">
                        <router-link :to="{ name: banner.link }"><img :src="banner.image"/></router-link>
                    </template>
                    <template v-else>
                        <img :src="banner.image"/>
                    </template>
                </li>
            </ul>
        </div>
        <div v-if="slidesCount > 1" class="glide__bullets" data-glide-el="controls[nav]">
            <button v-for="i in slidesCount" :key="i" class="glide__bullet" :data-glide-dir="`=${i-1}`"></button>
        </div>
    </div>
</template>
<script>
import Glide from '@glidejs/glide';

export default {
    name: 'sport-top-banner',
    props: {
        banners: {
            type: Array,
            required: true,
        }
    },
    computed: {
        slidesCount () {
            return this.banners.length;
        }
    },
    async created() {
        setTimeout(() => {
            new Glide('.glide', { autoplay: 5000, hoverpause: false }).mount();
        });
    }
};
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/common/banners/sport-banners/sport-top-banner.vue